// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_CancelarCompraResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combos/cancelar_compra (NS 2026-0090, fatia 5).
 *
 * `movement_id` = o `cancelamento` gravado (0 quando nao havia par
 * disponivel a anular), `pares_cancelados` = os pares que ele anulou,
 * `status` = cancelada, e o saldo da compra depois dele (disponivel 0).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Combos_CancelarCompraResponseDados {
combo_purchase_id: number
movement_id: number
pares_cancelados: number
status: string
quantidade: number
reservado: number
consumido: number
disponivel: number
}

export type Combos_CancelarCompraResponse = ApiResponse<Combos_CancelarCompraResponseDados>;

registerResponseContract('Combos_CancelarCompraResponse', {
  combo_purchase_id: { type: 'number',  required: true },
  movement_id:       { type: 'number',  required: true },
  pares_cancelados:  { type: 'number',  required: true },
  status:            { type: 'string',  required: true },
  quantidade:        { type: 'number',  required: true },
  reservado:         { type: 'number',  required: true },
  consumido:         { type: 'number',  required: true },
  disponivel:        { type: 'number',  required: true },
})
